export default function CountryBreakdownTable({ rows = [] }) {
  return (
    <section className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
      <h2 className="text-lg font-semibold text-slate-950">Country breakdown</h2>
      <p className="text-sm text-slate-500">Top countries by watch views.</p>
      <div className="mt-5 overflow-x-auto">
        <table className="min-w-full divide-y divide-slate-200 text-sm">
          <thead>
            <tr className="text-left text-xs font-semibold uppercase tracking-[0.12em] text-slate-500">
              <th className="py-3 pr-4">Country</th>
              <th className="px-4 py-3">Page views</th>
              <th className="px-4 py-3">Watch views</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {rows.slice(0, 10).map((row) => (
              <tr key={row.country}>
                <td className="py-3 pr-4 font-semibold text-slate-800">{row.country}</td>
                <td className="px-4 py-3 font-mono text-slate-700">{row.page_views}</td>
                <td className="px-4 py-3 font-mono text-slate-700">{row.watch_views}</td>
              </tr>
            ))}
            {!rows.length && (
              <tr><td className="py-4 text-slate-500" colSpan="3">No country data yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}
